var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._g(_vm._b({},'v-dialog',_vm.$attrs,false),_vm.$listeners),[_c('v-card',[_c('v-card-title',{attrs:{"id":"c-title"}},[_vm._t("header")],2),_c('v-divider'),_c('v-card-text',{attrs:{"id":"c-body"}},[_vm._t("body")],2),_c('v-divider'),_c('v-card-actions',{attrs:{"id":"c-footer"}},[_vm._t("footer")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }